export default __webpack_public_path__ + "static/media/trashCan.dbe38afb.svg";